import { PROFILE_CONFIGURABLE_STAGES, isRequiredStage, type CanonicalStage, type Profile } from '@capture/shared';
import { StageCard } from './StageCard';

export interface StageRailProps {
  profile: Profile;
  selectedStage: CanonicalStage | null;
  onSelect: (s: CanonicalStage) => void;
  onToggle: (s: CanonicalStage, nextEnabled: boolean) => void;
}

export function StageRail({ profile, selectedStage, onSelect, onToggle }: StageRailProps) {
  const enabledMap = new Map(profile.stages.map((s) => [s.stage, s.enabled]));
  return (
    <div className="stage-rail">
      {PROFILE_CONFIGURABLE_STAGES.map((s, i) => {
        const required = isRequiredStage(s);
        const enabled = required ? true : (enabledMap.get(s) ?? false);
        const last = i === PROFILE_CONFIGURABLE_STAGES.length - 1;
        return (
          <div key={s} className="stage-rail__group">
            <StageCard
              stage={s}
              enabled={enabled}
              required={required}
              selected={selectedStage === s}
              onSelect={() => onSelect(s)}
              onToggle={() => onToggle(s, !enabled)}
            />
            {!last && <span className="stage-arrow" aria-hidden="true">{'→'}</span>}
          </div>
        );
      })}
    </div>
  );
}
